var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHanLogoHeader({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 442.9",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HAN_Logo_1_",
    transform: "translate(-12.109 -12.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10_1_",
    transform: "translate(12.109 12.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2_1_",
    transform: "translate(63.056 31.015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4_1_",
    fill: "#FFFFFF",
    d: "M1016.9,412.9H760.2v-39h256.7V412.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5_1_",
    fill: "#FFFFFF",
    d: "M169.9,368V204.8H61.1V368H0V0h61.1v149.2h108.8V0H231v368H169.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6_1_",
    transform: "translate(42.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6_1_",
    fill: "#FFFFFF",
    d: "M676.6,368L573.4,108.2h-1.5l1,259.8h-55.5V0h70.3l102.2,261.5h1.5L691,0h53.4v368 H676.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8_1_",
    transform: "translate(19.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7_1_",
    fill: "#FFFFFF",
    d: "M420,0h-76.5l-60.8,247l-51,17.3l16,48.2l20.6-7L253,368h55.9l20.5-83.2l96.8-32.9 L454.7,368h55.9L420,0z M343.8,226.2L380,79.3h3.6l30.3,123.1L343.8,226.2z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHanLogoHeader);
export default __webpack_public_path__ + "static/media/han_logo_header.2b8d7852b4169c3a3aaff324bc7e63a9.svg";
export { ForwardRef as ReactComponent };